import React, { useEffect, useState } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { ArrowRight, Wallet } from 'lucide-react';
import CarbonCalculator from './CarbonCalculator';

/**
 * Sticky CTA mobile — uniquement sur la home, visible après scroll de 1 viewport.
 * Best practice Baymard : impact +20-30% sur la conversion mobile.
 *
 * - Visible uniquement sur < md (mobile)
 * - Visible uniquement sur la page "/"
 * - Visible uniquement après que l'utilisateur a scrollé hors du hero
 *   (évite la duplication visuelle avec le CTA principal)
 */
const MobileStickyCTA = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const [visible, setVisible] = useState(false);
  const [calcOpen, setCalcOpen] = useState(false);

  useEffect(() => {
    if (location.pathname !== '/') {
      setVisible(false);
      return undefined;
    }
    const onScroll = () => {
      // Affiche après 80% du premier écran et masque dans le footer
      const scrolled = window.scrollY;
      const viewport = window.innerHeight;
      const doc = document.documentElement.scrollHeight;
      const nearBottom = scrolled + viewport >= doc - 200;
      setVisible(scrolled > viewport * 0.8 && !nearBottom);
    };
    window.addEventListener('scroll', onScroll, { passive: true });
    onScroll();
    return () => window.removeEventListener('scroll', onScroll);
  }, [location.pathname]);

  if (location.pathname !== '/') return null;

  return (
    <>
      <div
        className={`md:hidden fixed bottom-0 inset-x-0 z-40 px-3 pb-3 pt-2 transition-transform duration-300 ${
          visible ? 'translate-y-0' : 'translate-y-full'
        }`}
        data-testid="mobile-sticky-cta"
        aria-hidden={!visible}
      >
        <div className="rounded-xl bg-[#1A3622] shadow-2xl shadow-[#1A3622]/30 border border-[#d4a574]/30 backdrop-blur-sm">
          <div className="flex items-stretch gap-2 p-2">
            <button
              type="button"
              onClick={() => setCalcOpen(true)}
              className="flex-1 flex items-center justify-center gap-2 rounded-lg bg-[#d4a574] hover:bg-[#c49564] text-[#1A3622] font-bold text-sm py-3 transition-colors"
              data-testid="sticky-cta-estimer"
            >
              <Wallet className="h-4 w-4" />
              Estimer ma rémunération
              <ArrowRight className="h-4 w-4" />
            </button>
            <button
              type="button"
              onClick={() => navigate('/register')}
              className="flex items-center justify-center rounded-lg border border-white/30 text-white text-xs font-semibold px-3 py-3 hover:bg-white/10 transition-colors whitespace-nowrap"
              data-testid="sticky-cta-inscrire"
              aria-label="S'inscrire gratuitement"
            >
              S'inscrire
            </button>
          </div>
        </div>
      </div>

      <CarbonCalculator isOpen={calcOpen} onClose={() => setCalcOpen(false)} />
    </>
  );
};

export default MobileStickyCTA;
